angular.module('contabilidad.reportenominasmovimientos')
  .config(function ($stateProvider) {
    $stateProvider.state('contabilidad.reportenominasmovimientos', {
      url: '/reportenominasmovimientos?{empresa_id}&{fechaInicial:date}&{fechaFinal:date}&{reporte}&{filtro_fecha}&{conceptos}&{clientes}&{regimenes_fiscales:int}',
      reloadOnSearch: false,
      params: {conceptos: {array: true, value: []}, clientes: {array: true, value: []}},
      data: {title: 'Reporte de movimientos de nóminas'},
      resolve: {
        busqueda: function ($stateParams) {
          return $stateParams
        },
      },
      template: '<contabilidad-reportenominasmovimientos busqueda="busqueda"/>',
      controller: function Controller ($scope, busqueda) {
        $scope.busqueda = busqueda
      },
    })
  })



// WEBPACK FOOTER //
// ./src/contabilidad/reportenominasmovimientos/routes/contabilidad-reportenominasmovimientos.js